const keyPrefix = "c241001_";

const maskImages = {
    "1_1": {
        filter: [ "./images/mask/1_1/filter_001.png", "./images/mask/1_1/filter_002.png", "./images/mask/1_1/filter_003.png", "./images/mask/1_1/filter_004.png" ],
        point: [ { x: 80, y: 110 },
                 { x: 170, y: 120 },
                 { x: 248, y: 120 },
                 { x: 325, y: 135 } ],
        match: 0.50,
        dis_match: 0.50,
        is_special: true
    },
    "1_2": {
        filter: [ "./images/mask/1_2/filter_001.png", "./images/mask/1_2/filter_002.png", "./images/mask/1_2/filter_003.png", "./images/mask/1_2/filter_004.png" ],
        point: [ { x: 100, y: 125 },
                 { x: 170, y: 120 },
                 { x: 255, y: 115 },
                 { x: 310, y: 125 } ],
        match: 0.50,
        dis_match: 0.50,
        is_special: true
    },
    "1_3": {
        filter: [ "./images/mask/1_3/filter_001.png", "./images/mask/1_3/filter_002.png", "./images/mask/1_3/filter_003.png", "./images/mask/1_3/filter_004.png" ],
        point: [ { x: 110, y: 110 },
                 { x: 140, y: 110 },
                 { x: 115, y: 140 },
                 { x: 150, y: 145 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
    "1_4": {
        filter: [ "./images/mask/1_4/filter_001.png", "./images/mask/1_4/filter_002.png", "./images/mask/1_4/filter_003.png", "./images/mask/1_4/filter_004.png"  ],
        point: [ { x: 60, y: 90 },
                 { x: 100, y: 125 },
                 { x: 130, y: 140 },
                 { x: 140, y: 125 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },

    "2_1": {
        filter: [ "./images/mask/2_1/filter_001.png", "./images/mask/2_1/filter_002.png", "./images/mask/2_1/filter_003.png", "./images/mask/2_1/filter_004.png" ],
        point: [ { x: 140, y: 40 },
                 { x: 200, y: 95 },
                 { x: 225, y: 155 },
                 { x: 285, y: 115 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: true
    },
    "2_2": {
        filter: [ "./images/mask/2_2/filter_001.png", "./images/mask/2_2/filter_002.png", "./images/mask/2_2/filter_003.png", "./images/mask/2_2/filter_004.png" ],
        point: [ { x: 130, y: 55 },
                 { x: 175, y: 90 },
                 { x: 240, y: 135 },
                 { x: 270, y: 110 }],
        match: 0.55,
        dis_match: 0.55,
        is_special: true
    },
    "2_3": {
        filter: [ "./images/mask/2_3/filter_001.png", "./images/mask/2_3/filter_002.png", "./images/mask/2_3/filter_003.png", "./images/mask/2_3/filter_004.png" ],
        point: [ { x: 155, y: 130 },
                 { x: 90, y: 135 },
                 { x: 98, y: 155 },
                 { x: 140, y: 160 }],
        match: 0.60,
        dis_match: 0.60,
        is_special: false
    },
    "2_4": {
        filter: [ "./images/mask/2_4/filter_001.png", "./images/mask/2_4/filter_002.png", "./images/mask/2_4/filter_003.png", "./images/mask/2_4/filter_004.png" ],
        point: [ { x: 75, y: 105 },
                 { x: 100, y: 145 },
                 { x: 150, y: 155 },
                 { x: 160, y: 130 }],
        match: 0.60,
        dis_match: 0.60,
        is_special: false
    },
    "2_5": {
        filter: [ "./images/mask/2_5/filter_001.png", "./images/mask/2_5/filter_002.png", "./images/mask/2_5/filter_003.png", "./images/mask/2_5/filter_004.png", "./images/mask/2_5/filter_005.png" ],
        point: [ { x: 70, y: 130 },
                 { x: 135, y: 135 },
                 { x: 90, y: 145 },
                 { x: 120, y: 115 },
                 { x: 170, y: 135 } ],
        match: 0.60,
        dis_match: 0.60,
        is_special: false
    },
    "2_6": {
        filter: [ "./images/mask/2_6/filter_001.png", "./images/mask/2_6/filter_002.png", "./images/mask/2_6/filter_003.png", "./images/mask/2_6/filter_004.png" ],
        point: [ { x: 80, y: 85 },
                 { x: 105, y: 140 },
                 { x: 125, y: 150 },
                 { x: 150, y: 142 } ],
        match: 0.60,
        dis_match: 0.60,
        is_special: false
    },

    "3_1": {
        filter: [ "./images/mask/3_1/filter_001.png", "./images/mask/3_1/filter_002.png", "./images/mask/3_1/filter_003.png", "./images/mask/3_1/filter_004.png"],
        point: [ { x: 105, y: 135 },
                 { x: 50, y: 155 },
                 { x: 80, y: 108 },
                 { x: 160, y: 95 }],
        match: 0.45,
        dis_match: 0.45,
        is_special: false
    },
    "3_2": {
        filter: [ "./images/mask/3_2/filter_001.png", "./images/mask/3_2/filter_002.png", "./images/mask/3_2/filter_003.png", "./images/mask/3_2/filter_004.png"],
        point: [ { x: 75, y: 115 },
                 { x: 102, y: 150 },
                 { x: 125, y: 90 },
                 { x: 158, y: 130 }],
        match: 0.60,
        dis_match: 0.60,
        is_special: false
    },
    "3_3": {
        filter: [ "./images/mask/3_3/filter_001.png", "./images/mask/3_3/filter_002.png", "./images/mask/3_3/filter_003.png", "./images/mask/3_3/filter_004.png" ],
        point: [ { x: 70, y: 105 },
                 { x: 100, y: 135 },
                 { x: 150, y: 135 },
                 { x: 155, y: 110 } ],
        match: 0.55,
        dis_match: 0.55,
        is_special: false
    },
};
exports.objCountList = [4, 6, 3];
exports.isInited = false;

exports.setCookie = function(key, value){
    localStorage.setItem(keyPrefix + key, value);
}

exports.getCookie = function(key){
    return localStorage.getItem(keyPrefix + key);
}
exports.removeCookie = function(key){
    localStorage.removeItem(keyPrefix + key);
}
exports.loadFoundList = function(){
    
    let foundModelList = this.getCookie("found_model");
    if(foundModelList === undefined){
        foundModelList = false;
    }else{
        foundModelList = JSON.parse(foundModelList);
    }
    if(!Array.isArray(foundModelList)){
        foundModelList = [];
        for( var j = 0;j < this.objCountList.length;j++ ){
            foundModelList[j] = [];
            for( var i = 0;i < this.objCountList[j];i++ ){
                foundModelList[j][i] = false;
            }
        }
    }
    this.setCookie( "found_model", JSON.stringify(foundModelList) );
    
    return foundModelList;
}
exports.getMaskData = function(id){
    if( id in maskImages ){
        return maskImages[id];
    }
    return null;
}

exports.init = function(){
    
    exports.isInited = true;
}